import React, { useCallback } from 'react';
import { nanoid } from 'nanoid';
import { FilterGroup, InputFilter } from '@lt/components';
import { useTranslation, i18n } from '@lt/localization';

import type { IFilter } from '../types';

const FilterHotelNameComponent: React.FC<IFilter> = ({
  data,
  onChange,
  onClear,
  className,
  isMobile,
}) => {
  const { filterName, filterLabel } = FilterHotelName;
  const { value: filterValue } = data;
  const isActive = Boolean(filterValue);
  const { t } = useTranslation();

  const changeHandler = useCallback(
    (value) => {
      const path = FilterHotelName.filterName;
      onChange({ path, diff: { value } });
    },
    [onChange],
  );

  if (isMobile) {
    // TODO: not implemented on mobile
    return null;
  }

  return (
    <FilterGroup
      className={className}
      label={filterLabel}
      showClearBtn={isActive}
      onClear={() => onClear(filterName)}
    >
      <InputFilter
        // null value resets filter (clear filter action)
        key={filterValue === null ? nanoid() : undefined}
        placeholder={t('filters.hotel_name.input')}
        onChange={changeHandler}
        externalValue={filterValue}
      />
    </FilterGroup>
  );
};

/* Для совместимости с конейнером фильтров */
export const FilterHotelName = Object.assign(FilterHotelNameComponent, {
  filterName: 'hotel_name',
  filterLabel: i18n.t('filters.hotel_name.title'),
  valuesLabel: (data) => data.value,
});

export default FilterHotelName;
